<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white px-10 py-12 rounded-xl shadow-lg w-full max-w-md text-center space-y-6">
      <!-- Logo -->
      <img alt="Charter Place Logo" src="/img/full_logo.svg" class="mx-auto w-40" />

      <!-- Title -->
      <h1 class="text-2xl font-bold text-neutral-800">Welcome to CharterPlace</h1>
      <p class="text-sm text-neutral-500">Please choose an Dashboard option to get started</p>

      <!-- Buttons -->
      <div class="space-y-3">
        <!-- Dashboard -->
        <RouterLink :to="{ name: 'Dashboard' }" class="block">
          <AButton class="btn btn-outline w-full mt-2"> Dashboard </AButton>
        </RouterLink>

        <!-- Django Admin -->
        <a :href="adminUrl" target="_blank" class="block pt-2">
          <button class="btn btn-warning w-full flex items-center justify-center gap-2">
            <i class="bi bi-shield-lock-fill"></i>
            Django Admin Access
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useAppStore} from "@/stores";
import AButton from "@/components/atoms/AButton.vue";

const appStore = useAppStore();
const adminUrl = appStore.AdminUrl;
</script>